export const itensFiltro = [
    {
        nomeColuna: "N Pedido",
        field: "pedido",
    },
    {
        nomeColuna: "Rota",
        field: "tipoRota",
    },
    {
        nomeColuna: "Frete Fiscal",
        field: "freteFiscal",
    },
    {
        nomeColuna: "ICMS",
        field: "icms",
    },
    {
        nomeColuna: "Pedagio",
        field: "pedagio",
    },
    {
        nomeColuna: "Classificação",
        field: "classificacao",
    },
    {
        nomeColuna: "Km",
        field: "km",
    },
    {
        nomeColuna: "Cliente",
        field: "cliente",
    },
    {
        nomeColuna: "Embarcador",
        field: "embarcador",
    },
    {
        nomeColuna: "Destinatario",
        field: "destinatario",
    },
    {
        nomeColuna: "Frete Motorista",
        field: "freteMotorista",
    },
    {
        nomeColuna: "Observação",
        field: "observacao",
    },
];

export const colunasHistorico = [
    {
        nomeColuna: "N Pedido",
        field: "pedido",
    },
    {
        nomeColuna: "Rota",
        field: "tipoRota",
    },
    {
        nomeColuna: "Frete Fiscal",
        field: "freteFiscal",
        tipo: "number",
    },
    {
        nomeColuna: "ICMS",
        field: "icms",
    },
    {
        nomeColuna: "Pedagio",
        field: "pedagio",
        tipo: "number",
    },
    {
        nomeColuna: "Classificação",
        field: "classificacao",
        tipo: "number",
    },
    {
        nomeColuna: "Km",
        field: "km",
        tipo: "number",
    },
    {
        nomeColuna: "Cliente",
        field: "cliente",
    },
    {
        nomeColuna: "Embarcador",
        field: "embarcador",
    },
    {
        nomeColuna: "Destinatario",
        field: "destinatario",
    },
    {
        nomeColuna: "Frete Motorista",
        field: "freteMotorista",
        tipo: "number",
    },
    {
        nomeColuna: "Observação",
        field: "observacao",
    },
    {
        nomeColuna: "Data Alteração",
        field: "data",
    },
    {
        nomeColuna: "Usuário",
        field: "usuario",
    },
];